import { Component, Inject, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { ToastrService } from 'ngx-toastr';
import { AppSettings } from 'src/app/core/common/app-settings';
import { OperacionEnum } from 'src/app/core/enums/operacion.enum';
import { GrupoService } from 'src/app/core/services/caso/grupo.service';
import { NotificacionService } from 'src/app/core/services/caso/notificacion.service';
import { SocioService } from 'src/app/core/services/caso/socio.service';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { GrupoVo } from 'src/app/shared/models/caso/grupo/grupo-vo.model';
import { NotificacionDto } from 'src/app/shared/models/caso/notificacion/notificacion-dto.model';
import { NotificacionVo } from 'src/app/shared/models/caso/notificacion/notificacion-vo.model';
import { SocioVo } from 'src/app/shared/models/caso/socio/socio-vo.model';
import { formatDate } from '@angular/common';
import { DatePipe } from '@angular/common';
import { format } from 'date-fns';
import { PublicadoVo } from 'src/app/shared/models/caso/publicado-vo.model';
import { PublicadoDto } from 'src/app/shared/models/caso/publicado-dto.model';
import { environment } from 'src/environments/environment';
import { DesaparecidoGamVo } from 'src/app/shared/models/gam/desaparecido-gam-vo.model';

@Component({
  selector: 'vex-gam-publicado-view',
  templateUrl: './publicado-view.component.html',
  styleUrls: ['./publicado-view.component.scss']
})
export class PublicadoViewComponent implements OnInit {

  appSettings = AppSettings;
  form: FormGroup;
  notificacionService = inject(NotificacionService);
  grupoService = inject(GrupoService);
  socioService = inject(SocioService);
  public operation: OperacionEnum;
  dto: PublicadoDto = new PublicadoDto();
  vo: DesaparecidoGamVo;
  grupos: GrupoVo[];
  socios: SocioVo[];
  tiposNotificacion: string[] = ['EMAIL', 'SMS', 'WHATSAPP', 'PUSH'];
  isGroup: boolean = true;
  datepipe: DatePipe;

  hours: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
  shours: string[] = ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"];
  tipoPrograma: string[] = ['AHORA', 'DESPUES'];
  prioridad: string[] = ['BAJA', 'MEDIA', 'ALTA'];
  showDespues: boolean = false;
  selectedOption = 'AHORA';
  selectedPrioridad = 'ALTA';
  tiempo = 20;

  constructor(private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    private toastrService: ToastrService) {
    this.operation = data.operation;
    this.vo = data.entity;

  }

  ngOnInit(): void {

  }

  foto(): string {
    return environment.apiSecurityUrl + 'api/v1/publicados/' + this.vo.id + '/afiche?' + (new Date()).getTime();
    //return environment.apiSecurityUrl + 'api/v1/ximages/' + this.vo.id + '/gray?' + (new Date()).getTime();
  }
}
